import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'wdx-tabs',
    templateUrl: './wdx-tabs.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxTabsComponent {}
